module.exports = __webpack_public_path__ + "media/Audio15_g.3c853a94.wav";